import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { ContractNoticeMode } from './mode/ContractNoticeMode';
import { ContractNoticeService } from '../../service/ContractNoticeService';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { postUtagEvent, UTAG_EVENT_JSON } from '../../../public/utag';
import { OthersInfo } from '../../models/OthersInfo';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';

/**
 * 告知項目のご確認
 */
export class ContractNoticeComponentView extends BaseWindowViewScope<FirstScopeInfo> {
	// private変数 -----------------------------------------------------------------------------------------
	private m_PdfFlg: boolean 							= false;	// PDFダウンロードボタンフラグ
	// -----------------------------------------------------------------------------------------------------
	
	// DI情報  ----------------------------------------------------------------------------------------------
	@WprDI_Control
	private m_Answer: WprControlInfo 					= null;		// 謝絶承諾処理ボタン
	// ------------------------------------------------------------------------------------------------------

	// モデル -----------------------------------------------------------------------------------------------
	@WprDI_ScopeModel('ContractNoticeInfo')
	@WprListData('ContractNoticeInfo')
	@WprModel('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 	= null;		// 告知事項
	@WprDI_ScopeModel('OthersInfo')
	private m_OthersInfo: 			OthersInfo 			= null; 	// その他情報
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 									= null;							// 商品コード
	// ------------------------------------------------------------------------------------------------------

	// コンストラクタ  ---------------------------------------------------------------------------------------
	constructor() {
		super('step3_important');
	}
	// ------------------------------------------------------------------------------------------------------

	// サブビュー/モード  -------------------------------------------------------------------------------------
	@WprViewMode
	private m_ViewMode = new ContractNoticeMode(); // 単一モード
	// -------------------------------------------------------------------------------------------------------
	
	// サービス  ----------------------------------------------------------------------------------------------
	private m_ContractNoticeService: ContractNoticeService = new ContractNoticeService();	// 告知事項サービス
	// -------------------------------------------------------------------------------------------------------

	// override メソッド  -------------------------------------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('answer', '回答ラジオボタン', null);
		this.addConfig('box-button', '謝絶処理', null);
		this.addConfig('pdf', 'PDFダウンロードボタン',null, {bindModel: true});
		this.addConfig('next', '次に進む', null);
		// 告知事項
		this.addListConfig('noticeMessage', '告知事項メッセージ', 'ContractNoticeInfo');
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		super.onRegisterAction();
		this.addAction('box-button', this.onConsent);
		this.addAction('pdf', this.onDownLoad);
		this.addAction('next', this.onNext);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (!this.m_ContractNoticeList.length) {
			this.onViewError();
		} 
		else {
			this.setListData('ContractNoticeInfo', this.m_ContractNoticeList);
			this.m_Answer.value = '';
			if (this.prevViewName === 'step4_mail-registration') {
				this.m_Answer.value = 'yes';
				this.m_PdfFlg = true;
			}
			this.onUtagView();
			this.refreshModel();
		}
	}

	/**
	 * 値変更通知
	 * @param name 名前
	 * @param value 値
	 * @returns falseの場合、変更を取り消す
	 */
	public onChangeValue(name: string, value: any): boolean {
		if (name === 'answer') {
			this.setViewMode('answerMode', value);
			this.setUtagEvent(name, value);
		}
		return true;
	}

	/**
	 * Tealium Event Tag 
	 * @param param 
	 */
	public setUtagEvent(param:any, value:any): void{
		const cat = UTAG_EVENT_JSON[0].contract_notice;
		const ev = UTAG_EVENT_JSON[1].ev_click;
		const evVal = UTAG_EVENT_JSON[2].ev_value;
		if(param === 'answer')
			postUtagEvent(cat, ev, value, evVal);
		else 
			postUtagEvent(cat, ev, 'pdf_important', evVal);
		// console.log('UtagEvent: '+cat);
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 謝絶承諾処理
	 */
	public onConsent(): void {
		this.m_Answer.value = '';
		this.setViewMode('answerMode', this.m_Answer.value);
		this.refreshModel();
	}

	/**
	 * PDFダウンロード処理
	 */
	public onDownLoad(): void {
		this.m_PdfFlg = true;
		if(this.m_OthersInfo.url)
			window.open(this.m_OthersInfo.url,'url');
		this.setUtagEvent(name, null);
		this.refreshModel();
	}

	/**
	 * 画面遷移処理
	 */
	public onNext(): void {
		this.pushPath('/step4_mail-registration');
	}
	// --------------------------------------------------------------------------
}
